import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Download Istantaneo', 'Nessun Abbonamento', 'Accesso a Vita', 'Garanzia di 7 Giorni'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-109" data-mp="9ll98xi2jyni">
      <div className="mx-auto max-w-4xl text-center" data-id="element-110" data-mp="4lyw0o28qiep">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[2.5rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.2rem]" data-id="element-111" data-mp="4na06ozlls6c">
          Risolvi un Intero Anno di Lezioni di Scienze in soli{' '}
          <span className="italic text-brand" data-id="element-112" data-mp="nbop96qcuw4i">5 Minuti</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-113" data-mp="3d2labedjz91r">
          Unisciti a oltre 1.500 insegnanti che hanno smesso di improvvisare.
          Entra in classe con tutto pronto per spiegare, sperimentare e
          ispirare.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-114" data-mp="3e8egb8bghk3y">
          <img src="https://cdn.magicpatterns.com/uploads/nAb4hSFX69BSJuoxFeR4p5/8ef8c362-c1c1-4fef-9a97-c5606e82ac05.webp" alt="Il pacchetto SCIENZE PRONTA: gli otto volumi dalla 1ª Primaria alla 3ª Media con il Kit Laboratorio, la piattaforma digitale su desktop, tablet e smartphone e i 5 bonus inclusi" className="mx-auto w-[70%] max-w-sm sm:w-[66%]" data-id="element-115" data-mp="2qkmv1f7xtwqj" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mt-2 sm:mt-8" data-id="element-116" data-mp="s1rsopcm88ut">
          <CtaButton href="#offer" data-id="element-117" data-mp="ichz1524ii4l" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-118" data-mp="ddf3cb819o9a">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-119" data-mp="1ayt8l57pjtdj" data-mpi={index}>
                <span data-id="element-120" data-mp="16346au4azydj">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-121" data-mp="1126polyxzce5">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}